import React from "react";
import { IoClose } from "react-icons/io5";

const MoveUploadModal = ({
  movingItem,
  selectedOrg,
  folderTree,
  targetParentId,
  setTargetParentId,
  onClose,
  onMove,
  isCopy = false,
  isPending = false,
}) => {
  if (!movingItem) return null;

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/40 backdrop-blur-sm animate-in fade-in duration-150">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-hidden animate-in zoom-in-95 duration-150">
        <div className="flex items-center justify-between px-6 pt-6 pb-4 border-b border-slate-100">
          <h2 className="text-base font-bold text-slate-900">{isCopy ? "Copy" : "Move"} {movingItem.type}</h2>
          <button
            onClick={onClose}
            disabled={isPending}
            className="p-1.5 rounded-lg hover:bg-slate-100 text-slate-400 hover:text-slate-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <IoClose size={18} />
          </button>
        </div>
        <div className="px-6 py-5 space-y-4">
          <p className="text-xs text-slate-500">
            {isCopy ? "Copy" : "Move"} <span className="font-semibold text-slate-800">"{movingItem.name}"</span> to:
          </p>
          <div>
            <label className="block text-xs font-semibold text-slate-700 mb-1.5">Select Destination Folder</label>
            <select
              value={targetParentId}
              disabled={isPending}
              onChange={(e) => setTargetParentId(e.target.value)}
              className="w-full px-3 py-2.5 text-sm border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/40 focus:border-indigo-400 transition-all bg-white disabled:opacity-60 disabled:cursor-not-allowed"
            >
              <option value="">Select a folder...</option>
              {/* Root / Org level */}
              {selectedOrg && (
                <option value={0}>
                  {/* <option value={selectedOrg.organizationsDNSId}> */}
                  [Root] {selectedOrg.organizationsName}
                </option>
              )}
              {/* Recursive list of folders */}
              {folderTree.map((f) => {
                const flatten = (node, prefix = "") => {
                  const list = [{ id: node.folderDNSID ?? node.folderID ?? node.id, name: `${prefix}${node.folderName}` }];
                  if (node.children) {
                    node.children.forEach((c) => {
                      list.push(...flatten(c, `${prefix}  └─ `));
                    });
                  }
                  return list;
                };
                return flatten(f).map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ));
              })}
            </select>
          </div>
        </div>
        <div className="flex items-center justify-end gap-3 px-6 pb-6 pt-4 border-t border-slate-100 bg-slate-50/50">
          <button
            onClick={onClose}
            disabled={isPending}
            className="px-4 py-2 text-sm font-semibold text-slate-600 hover:text-slate-800 hover:bg-slate-100 rounded-xl transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            onClick={onMove}
            disabled={!targetParentId || isPending}
            className="px-5 py-2 text-sm font-semibold bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed text-white rounded-xl transition-colors shadow-sm shadow-indigo-200"
          >
            {isPending ? (isCopy ? "Copying..." : "Moving...") : (isCopy ? "Copy" : "Move")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MoveUploadModal;
